export default "/images/redelcom.png?2b09b41d914b458029c6216e94a11335";